module.exports = __webpack_public_path__ + "media/VIDEO.75beca4b.mp4";